<template>
  <div>
    <div class="row evollu-form">
      <!--Created At Filter --->

    </div>

    <v-server-table
      :id="componentRef"
      :ref="componentRef"
      :name="componentRef"
      :columns="columns"
      :options="tableOptions"
      @loaded="onLoaded"
      @loading="onLoading"
      @row-click="handleLeadClicked"
      @filter="onFilterUpdate"
    >
      <span slot="createdAt" class="no-break" slot-scope="props">{{ props.row.createdAt | localTime('YYYY-MM-DD HH:mm') }}</span>
      <span slot="name" class="no-break" slot-scope="props">{{props.row.person ? props.row.person.name ? props.row.person.name : "N/A" : "N/A"}}</span>
      <span slot="email" class="no-break" slot-scope="props">{{props.row.person ? props.row.person.email ? props.row.person.email : "N/A" : "N/A"}}</span>
      <span slot="mobilePhone" class="no-break" slot-scope="props">{{props.row.person ? props.row.person.mobilePhone ? props.row.person.mobilePhone : "N/A" : "N/A"}}</span>
      <span slot="entity" class="no-break" slot-scope="props"> {{handleEntityName(props.row)}}</span>
      <span v-for="param in healthParams" :slot="param.name" class="no-break" slot-scope="props"> {{extractValue(props.row, param)}}</span>


    </v-server-table>
  </div>
</template>

<script>
 import IsFromEvolluMixin from '@/mixins/IsFromEvolluMixin.vue';
 import TableQueryMixin from '@/mixins/TableQueryMixin.vue';
 import MultiselectLabelFormatter from '@/mixins/MultiselectLabelFormatter.vue';
 import ClustersAndEntitiesMixin from '@/mixins/ClustersAndEntitiesMixin.vue';
 import RangeDatePicker from '@/components/common/RangeDatePicker.vue';
 import Multiselect from 'vue-multiselect';

 export default {
   components: { Multiselect, RangeDatePicker },
   props: {
     componentRef: {
       type: String,
       required: true
     },
     healthParams: {
       type: Array,
       required: true,
     },
     authorizedEntities: {
       type: Array,
       required: true,
     },
     filters: {
       type: Object,
       required: true
     },
     columns: {
       type: Array,
       required: true
     }
   },
   mixins: [
     IsFromEvolluMixin,
     TableQueryMixin,
     MultiselectLabelFormatter,
     ClustersAndEntitiesMixin
   ],
   data () {
     return {
       tableOptions: {
         orderBy: {
           column: 'createdAt',
           ascending: false
         },
         saveState: true,
         storage: 'local',
         filterable: true,
         sortable: ['createdAt'],
         customFilters: ['start', 'end', 'entities'],
         headings: {
           createdAt: this.$t('leads.table.created_at'),
           name: this.$t('biosigns.columns.name'),
           email: this.$t('biosigns.columns.email'),
           mobilePhone: this.$t('biosigns.columns.mobilePhone'),
           entity: this.$t('biosigns.columns.entity'),
           heartRate: this.$t('evohealth.healthParameters.heartRate'),
           heartRateVariability: this.$t('evohealth.healthParameters.heartRateVariability'),
           sbp: this.$t('evohealth.healthParameters.systolicBloodPressure'),
           systolicBloodPressure: this.$t('evohealth.healthParameters.systolicBloodPressure'),
           diastolicBloodPressure: this.$t('evohealth.healthParameters.diastolicBloodPressure'),
           respiratoryRate: this.$t('evohealth.healthParameters.respiratoryRate'),
           oxygenSaturation: this.$t('evohealth.healthParameters.oxygenSaturation'),
           stressIndex: this.$t('evohealth.healthParameters.stressIndex'),
           ansIndexPns: this.$t('evohealth.healthParameters.ansIndexPns'),
           ansIndexSns: this.$t('evohealth.healthParameters.ansIndexSns'),
           temperature: this.$t('evohealth.healthParameters.temperature'),
           bloodGlucose: this.$t('evohealth.healthParameters.bloodGlucose'),
           fasting: this.$t('evohealth.healthParameters.fasting'),
           sessionDuration: this.$t('evohealth.healthParameters.sessionDuration'),
           minimumOxygenLevel: this.$t('evohealth.healthParameters.minimumOxygenLevel'),
           minimumHeartRate: this.$t('evohealth.healthParameters.minimumHeartRate'),
           meanOxygenLevel: this.$t('evohealth.healthParameters.meanOxygenLevel'),
           meanHeartRate: this.$t('evohealth.healthParameters.meanHeartRate'),
           maximumOxygenLevel: this.$t('evohealth.healthParameters.maximumOxygenLevel'),
           maximumHeartRate: this.$t('evohealth.healthParameters.maximumHeartRate'),
           FEV1: this.$t('evohealth.healthParameters.FEV1'),
           FEV6: this.$t('evohealth.healthParameters.FEV6'),
           'FEV1/FEV6': this.$t('evohealth.healthParameters.FEV1-FEV6'),
           'FEF25-75': this.$t('evohealth.healthParameters.FEF25-75'),
           weight: this.$t('evohealth.healthParameters.weight'),
           BMI: this.$t('evohealth.healthParameters.BMI'),
           bodyWater: this.$t('evohealth.healthParameters.bodyWater'),
           fatMass: this.$t('evohealth.healthParameters.fatMass'),
           bodyMuscleMass: this.$t('evohealth.healthParameters.bodyMuscleMass'),
           'SARC-F': this.$t('evohealth.healthParameters.SARC-F'),
           gripStrength: this.$t('evohealth.healthParameters.gripStrength'),
           walkTime: this.$t('evohealth.healthParameters.walkTime'),
           exhaustion: this.$t('evohealth.healthParameters.exhaustion'),
           physicalActivity: this.$t('evohealth.healthParameters.physicalActivity'),
           weightLoss: this.$t('evohealth.healthParameters.weightLoss'),
           totalCholesterol: this.$t('evohealth.healthParameters.totalCholesterol'),
           HDLCholesterol: this.$t('evohealth.healthParameters.HDLCholesterol'),
           LDLCholesterol: this.$t('evohealth.healthParameters.LDLCholesterol'),
           triglycerides: this.$t('evohealth.healthParameters.triglycerides'),
           cardiovascularRisk: this.$t('evohealth.healthParameters.cardiovascularRisk'),
           waist: this.$t('evohealth.healthParameters.waist'),
           chest: this.$t('evohealth.healthParameters.chest'),
           abdomen: this.$t('evohealth.healthParameters.abdomen'),
           arm: this.$t('evohealth.healthParameters.arm'),
           calf: this.$t('evohealth.healthParameters.calf'),
           thigh: this.$t('evohealth.healthParameters.thigh'),
           FEV1Predicted: this.$t('evohealth.healthParameters.FEV1Predicted'),
           mMRC: this.$t('evohealth.healthParameters.mMRC'),
           exacerbations: this.$t('evohealth.healthParameters.exacerbations'),
           hospitalizations: this.$t('evohealth.healthParameters.hospitalizations'),
           leukocyte: this.$t('evohealth.healthParameters.leukocyte'),
           nitrite: this.$t('evohealth.healthParameters.nitrite'),
           protein: this.$t('evohealth.healthParameters.protein'),
           glucose: this.$t('evohealth.healthParameters.glucose'),
           blood: this.$t('evohealth.healthParameters.blood'),
           ketoneBody: this.$t('evohealth.healthParameters.ketoneBody'),
           urobilinogen: this.$t('evohealth.healthParameters.urobilinogen'),
           bilirubin: this.$t('evohealth.healthParameters.bilirubin'),
           specificGravity: this.$t('evohealth.healthParameters.specificGravity'),
           pH: this.$t('evohealth.healthParameters.pH'),
           vitaminC: this.$t('evohealth.healthParameters.vitaminC'),
           AST: this.$t('evohealth.healthParameters.AST'),
           ALT: this.$t('evohealth.healthParameters.ALT'),
           'AST/ALT': this.$t('evohealth.healthParameters.AST/ALT'),
           acidLactic: this.$t('evohealth.healthParameters.acidLactic'),
           erythrocytes: this.$t('evohealth.healthParameters.erythrocytes'),
           hematocrit: this.$t('evohealth.healthParameters.hematocrit'),
           hemoglobin: this.$t('evohealth.healthParameters.hemoglobin'),
           hba1c: this.$t('evohealth.healthParameters.hba1c'),
           estimatedAverageGlucose: this.$t('evohealth.healthParameters.estimatedAverageGlucose'),
           FORT: this.$t('evohealth.healthParameters.FORT'),
           FORD: this.$t('evohealth.healthParameters.FORD'),
           redoxIndex: this.$t('evohealth.healthParameters.redoxIndex'),
           uricAcid: this.$t('evohealth.healthParameters.uricAcid'),
           finalScoreResult: this.$t('evohealth.healthParameters.finalScoreResult'),
           levelOfConsciousness: this.$t('evohealth.healthParameters.levelOfConsciousness'),
           supplementaryOxygenAdministered: this.$t('evohealth.healthParameters.supplementaryOxygenAdministered')
         },
         columnsClasses: {
           createdAt: 'created_at',
         }
       }
     }
   },
   async mounted() {
     //const healthParamsNames = this.healthParams.map(param => param.name)
     //this.columns.push(...healthParamsNames)
     if(this.authorizedEntities && this.authorizedEntities.length > 0) {
       this.filters.entities = [this.authorizedEntities[0]]
     }
   },
   methods: {
     reload: function () {
       this.$refs[this.componentRef].refresh()
     },
     onLoading: function () {
       this.$emit('loading')
     },
     onLoaded: function (state) {
       this.$emit('loaded', state)
     },
     handleLeadClicked: function ({ row }) {
       let selectedLead = row
       this.$emit('leadClicked', selectedLead)
     },
     handleEntityName: function (lead) {
       if(lead.entityId !== null) {
         const entity = this.authorizedEntities.find(entity => entity.id === lead.entityId)
         if(entity) {
           lead.entity = entity
           return entity.name
         }
       }

       return "N/A"
     },
     extractValue: function (lead, healthParam) {
       if(lead.values === null || lead.values.length === 0) {
         return "N/A"
       }
       const leadValues = lead.values.flatMap(val => val.leadValues)
       const leadValue = leadValues.find(val => val.healthParam.id === healthParam.id)
       if(leadValue && leadValue.value !== '' && leadValue.value !== null && leadValue.value !== undefined) {
         let valueText = leadValue.value
         if(healthParam.name === 'levelOfConsciousness') {
           return this.$t(`evohealth.healthParameters.news2.levelOfConsciousnessOptions.${valueText}`, "N/A")
         }
         if(healthParam.name === 'supplementaryOxygenAdministered'){
           return this.$t(`clinical.labels.${valueText}`, "N/A")
         }
         if(healthParam.unit) valueText += ` ${healthParam.unit}`
         return valueText
       }



       return "N/A"
     },
   },
   computed: {
     /*authorizedEntities: function () {
       let evohealthService = this.$store.state.services.find(service => service.url === this.$store.state.evohealth_server) || null
       if (evohealthService) {
         if (evohealthService.user_permissions.some(p => p.entity_id === null)) {
           return evohealthService.entities
         } else {
           return evohealthService.entities.filter(entity => evohealthService.user_permissions.filter(p => p.entity_id === entity.id))
         }
       }
       return []
     },*/
     queryUrl: function() {
       return `${this.$store.state.evohealth_server}v1/leads/${this.filters.healthGroup.id}/all`
     }
   },
   watch: {
     'filters.date': function (value) {
       this.$refs[this.componentRef].customQueries.start = value.start || ''
       this.emitTableFilter(`vue-tables.${this.componentRef}.filter::end`, value.end || '')
     },
     'filters.entities': {
       handler: function (value) {
         if (value) {
           const parsedIds = value.map(elem => parseInt(elem.id)).join(',')
           this.emitTableFilter(`vue-tables.${this.componentRef}.filter::entities`, parsedIds || '')
         }
        },
       immediate: true
     }
   }
 }

</script>


<style scoped lang="scss">

</style>
